<template>
  <div id="jumbotron" class="loading_Takeover bg_Splash" v-bind:style="{ 'background-image': 'url(/img/backgrounds/' + bgImage + ')' }">
    <div id="logo_Container">
      <img class="ap_Logo_Full" src="/img/logos/fullmark_white.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    navAvail: Boolean
  },
  data() {
    return {
      bgImage: null,
    }
  },
  mounted() {
    let images = [1, 2, 3, 4];
    let prevImg = localStorage.bgImage;
    if (!this._.isUndefined(prevImg) || prevImg != null){
      images = this._.remove(images, function(n) { return n != prevImg ; });
    }
    let sample = this._.sample(images);
    let output = `apm_${sample}.jpg`;
    localStorage.bgImage = sample;
    this.bgImage = output;
  },
}
</script>
